import React from "react";
import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import CTAButton from "./CTAButton";
import { useSiteContent } from "../../hooks/useSiteContent";

export default function FAQ() {
  const { content } = useSiteContent();
  const faqs = [
    { q: content.faq1_q, a: content.faq1_a },
    { q: content.faq2_q, a: content.faq2_a },
    { q: content.faq3_q, a: content.faq3_a },
    { q: content.faq4_q, a: content.faq4_a },
    { q: content.faq5_q, a: content.faq5_a },
    { q: content.faq6_q, a: content.faq6_a },
    { q: content.faq7_q, a: content.faq7_a },
    { q: content.faq8_q, a: content.faq8_a },
  ];
  return (
    <section id="faq" className="py-24 lg:py-32 bg-card-gradient" data-testid="faq-section">
      <div className="container">
        <div className="max-w-3xl mb-12">
          <div className="eyebrow mb-4"><span className="kicker-line" />Dúvidas frequentes</div>
          <h2 className="text-4xl md:text-5xl font-display font-light">Perguntas <span className="italic text-gold-gradient">honestas</span>, respostas diretas.</h2>
        </div>
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="max-w-3xl">
          <Accordion type="single" collapsible className="space-y-2">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="bg-background border border-border data-[state=open]:border-primary/50 rounded-sm px-6 transition-colors">
                <AccordionTrigger className="text-left font-display text-base md:text-lg hover:text-primary py-5" data-testid={`faq-trigger-${i}`}>
                  <span className="flex items-center gap-4"><span className="font-mono text-xs text-primary">0{i + 1}</span>{f.q}</span>
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed pb-5 pl-10">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
        <CTAButton centered />
      </div>
    </section>
  );
}
